import { Button } from "@bindery/ui/components/ui/button";
import { Link } from "react-router";

export function NotFoundPage() {
  return (
    <main className="flex min-h-screen flex-col items-center justify-center p-8 text-center">
      <h1 className="mb-4 text-2xl font-bold">Page not found</h1>
      <p className="text-muted-foreground mb-6">
        We couldn&apos;t find that page. Your readings are all in the library.
      </p>
      <Button asChild size="lg">
        <Link to="/reader">Go to the Library</Link>
      </Button>
    </main>
  );
}
